// ⛔️Generated file. Manual changes will be lost ⛔️

import {
    Operation,
    MessagingClient,
    ServiceClient,
} from '@multipass-system';
import {
    AcceptLegalDocumentsRequestDto,
    AcceptLegalDocumentsResponseDto,
    AcceptTermsAndSignInRequestDto,
    AcceptTermsAndSignInResponseDto,
    DeleteAccountRequestDto,
    DeleteAccountResponseDto,
    GetLegalDocumentsRequestDto,
    GetLegalDocumentsResponseDto,
    GetUserRequestDto,
    GetUserResponseDto,
    SendLoginCodeRequestDto,
    SendLoginCodeResponseDto,
    SignOutRequestDto,
    SignOutResponseDto,
    SignUpRequestDto,
    SignUpResponseDto,
    UpdateUserLocaleRequestDto,
    UpdateUserLocaleResponseDto,
    UpdateUserScriptPreferenceRequestDto,
    UpdateUserScriptPreferenceResponseDto,
    VerifyLoginCodeRequestDto,
    VerifyLoginCodeResponseDto
} from '@multipass-user-service-dto';

export class UserServiceOperations {

    static AcceptLegalDocuments: Operation = {
        'key': 'multipass-user-service_AcceptLegalDocuments',
        'name': 'AcceptLegalDocuments',
        'version': '1.0.0',
        'route': '/user-svc/legal/accept',
        'method': 'POST',
    };

    static AcceptTermsAndSignIn: Operation = {
        'key': 'multipass-user-service_AcceptTermsAndSignIn',
        'name': 'AcceptTermsAndSignIn',
        'version': '1.0.0',
        'route': '/user-svc/session/accept-terms-and-sign-in',
        'method': 'POST',
    };

    static DeleteAccount: Operation = {
        'key': 'multipass-user-service_DeleteAccount',
        'name': 'DeleteAccount',
        'version': '1.0.0',
        'route': '/user-svc/account/delete',
        'method': 'POST',
    };

    static GetLegalDocuments: Operation = {
        'key': 'multipass-user-service_GetLegalDocuments',
        'name': 'GetLegalDocuments',
        'version': '1.0.0',
        'route': '/user-svc/legal/documents',
        'method': 'POST',
    };

    static GetUser: Operation = {
        'key': 'multipass-user-service_GetUser',
        'name': 'GetUser',
        'version': '1.0.0',
        'route': '/user-svc/user/get',
        'method': 'POST',
    };

    static SendLoginCode: Operation = {
        'key': 'multipass-user-service_SendLoginCode',
        'name': 'SendLoginCode',
        'version': '1.0.0',
        'route': '/user-svc/session/send-login-code',
        'method': 'POST',
    };

    static SignOut: Operation = {
        'key': 'multipass-user-service_SignOut',
        'name': 'SignOut',
        'version': '1.0.0',
        'route': '/user-svc/session/sign-out',
        'method': 'POST',
    };

    static SignUp: Operation = {
        'key': 'multipass-user-service_SignUp',
        'name': 'SignUp',
        'version': '1.0.0',
        'route': '/user-svc/session/sign-up',
        'method': 'POST',
    };

    static UpdateUserLocale: Operation = {
        'key': 'multipass-user-service_UpdateUserLocale',
        'name': 'UpdateUserLocale',
        'version': '1.0.0',
        'route': '/user-svc/user/locale',
        'method': 'POST',
    };

    static UpdateUserScriptPreference: Operation = {
        'key': 'multipass-user-service_UpdateUserScriptPreference',
        'name': 'UpdateUserScriptPreference',
        'version': '1.0.0',
        'route': '/user-svc/user/script-preference',
        'method': 'POST',
    };

    static VerifyLoginCode: Operation = {
        'key': 'multipass-user-service_VerifyLoginCode',
        'name': 'VerifyLoginCode',
        'version': '1.0.0',
        'route': '/user-svc/session/verify-login-code',
        'method': 'POST',
    };

}

export interface UserServiceClient extends ServiceClient {
    requestAcceptLegalDocuments(request: AcceptLegalDocumentsRequestDto, timeoutInMs?: number): Promise<AcceptLegalDocumentsResponseDto>;
    requestAcceptTermsAndSignIn(request: AcceptTermsAndSignInRequestDto, timeoutInMs?: number): Promise<AcceptTermsAndSignInResponseDto>;
    requestDeleteAccount(request: DeleteAccountRequestDto, timeoutInMs?: number): Promise<DeleteAccountResponseDto>;
    requestGetLegalDocuments(request: GetLegalDocumentsRequestDto, timeoutInMs?: number): Promise<GetLegalDocumentsResponseDto>;
    requestGetUser(request: GetUserRequestDto, timeoutInMs?: number): Promise<GetUserResponseDto>;
    requestSendLoginCode(request: SendLoginCodeRequestDto, timeoutInMs?: number): Promise<SendLoginCodeResponseDto>;
    requestSignOut(request: SignOutRequestDto, timeoutInMs?: number): Promise<SignOutResponseDto>;
    requestSignUp(request: SignUpRequestDto, timeoutInMs?: number): Promise<SignUpResponseDto>;
    requestUpdateUserLocale(request: UpdateUserLocaleRequestDto, timeoutInMs?: number): Promise<UpdateUserLocaleResponseDto>;
    requestUpdateUserScriptPreference(request: UpdateUserScriptPreferenceRequestDto, timeoutInMs?: number): Promise<UpdateUserScriptPreferenceResponseDto>;
    requestVerifyLoginCode(request: VerifyLoginCodeRequestDto, timeoutInMs?: number): Promise<VerifyLoginCodeResponseDto>;
}

const DefaultTimeoutInMs = 20_000;

export class UserServiceClientImpl implements UserServiceClient {

    constructor(private _messagingClient: MessagingClient) {}

    public requestAcceptLegalDocuments(request: AcceptLegalDocumentsRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<AcceptLegalDocumentsResponseDto> {
        return this._messagingClient.request<AcceptLegalDocumentsRequestDto, AcceptLegalDocumentsResponseDto>(
            UserServiceOperations.AcceptLegalDocuments,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestAcceptTermsAndSignIn(request: AcceptTermsAndSignInRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<AcceptTermsAndSignInResponseDto> {
        return this._messagingClient.request<AcceptTermsAndSignInRequestDto, AcceptTermsAndSignInResponseDto>(
            UserServiceOperations.AcceptTermsAndSignIn,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestDeleteAccount(request: DeleteAccountRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<DeleteAccountResponseDto> {
        return this._messagingClient.request<DeleteAccountRequestDto, DeleteAccountResponseDto>(
            UserServiceOperations.DeleteAccount,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestGetLegalDocuments(request: GetLegalDocumentsRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<GetLegalDocumentsResponseDto> {
        return this._messagingClient.request<GetLegalDocumentsRequestDto, GetLegalDocumentsResponseDto>(
            UserServiceOperations.GetLegalDocuments,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestGetUser(request: GetUserRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<GetUserResponseDto> {
        return this._messagingClient.request<GetUserRequestDto, GetUserResponseDto>(
            UserServiceOperations.GetUser,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestSendLoginCode(request: SendLoginCodeRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<SendLoginCodeResponseDto> {
        return this._messagingClient.request<SendLoginCodeRequestDto, SendLoginCodeResponseDto>(
            UserServiceOperations.SendLoginCode,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestSignOut(request: SignOutRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<SignOutResponseDto> {
        return this._messagingClient.request<SignOutRequestDto, SignOutResponseDto>(
            UserServiceOperations.SignOut,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestSignUp(request: SignUpRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<SignUpResponseDto> {
        return this._messagingClient.request<SignUpRequestDto, SignUpResponseDto>(
            UserServiceOperations.SignUp,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestUpdateUserLocale(request: UpdateUserLocaleRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<UpdateUserLocaleResponseDto> {
        return this._messagingClient.request<UpdateUserLocaleRequestDto, UpdateUserLocaleResponseDto>(
            UserServiceOperations.UpdateUserLocale,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestUpdateUserScriptPreference(request: UpdateUserScriptPreferenceRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<UpdateUserScriptPreferenceResponseDto> {
        return this._messagingClient.request<UpdateUserScriptPreferenceRequestDto, UpdateUserScriptPreferenceResponseDto>(
            UserServiceOperations.UpdateUserScriptPreference,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestVerifyLoginCode(request: VerifyLoginCodeRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<VerifyLoginCodeResponseDto> {
        return this._messagingClient.request<VerifyLoginCodeRequestDto, VerifyLoginCodeResponseDto>(
            UserServiceOperations.VerifyLoginCode,
            request,
            {timeoutMs: timeoutInMs}
        );
    }
}
